import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios';
// import router from '@/router';
import { db } from '@/main';

Vue.use(Vuex);

const defaultState = {
  step: 0,
  exam_type: null, // value of the exam, e.g. 'hand_elbow'
  is_loading: false,
  SHOW_RESULTS: false, // show the results screen
  // COLLECT_LEAD: false, // show the form to submit name and email
  
  exam: null, // the exam itself, including name and prompts
  exam_responses: {}, // { prompt: response, ... } mapping responses given in the form
  results_pic: null, // picture based on the exam type
  exam_results: null, // results returned by the backend
}



function random (min, max) {
  return min + Math.random() * (max - min);
}
// Get the exam type based on the url query passed, if there is one. If not the user will see a type selector
function get_exam_type() {
  let exam_type = null;
  const type = new URLSearchParams(window.location.search).get('type');
  if (type) {
    exam_type = type.toLowerCase();
  }
  return exam_type;
}


import { all_prompts } from '../../../functions/data/index';


export default new Vuex.Store({
  state: {
    step: 0,
    exam_type: null, // value of the exam, e.g. 'hand_elbow'
    is_loading: false,
    SHOW_RESULTS: false, // show the results screen
    // COLLECT_LEAD: false, // show the form to submit name and email

    exam: null, // the exam itself, including name and prompts
    exam_responses: {}, // { prompt: response, ... } mapping responses given in the form
    results_pic: null, // picture based on the exam type
    exam_results: null, // results returned by the backend
    show_disclaimer: true,
    session_id: '',
  },
  mutations: {
    SET_SESSION_ID(state, id) {
      state.session_id = id;
    },
    SET_SHOW_DISCLAIMER(state, val) {
      state.show_disclaimer = val;
    },
    // 
    
    // generic setting for any value
    SET_VALUE(state, { prop, val }) { 
      state[prop] = val;
    },
    SET_LOADING(state, value) {
      if (value) {
        state.is_loading = value;
      } else { // delay closing the loader
        setTimeout(() => {
          state.is_loading = value;
        }, random(350,820));
      }
    },

    NAVIGATE_STEP(state, forwards) {
      if (forwards) state.step = state.step+1;
      // else if (!forwards && state.COLLECT_LEAD) {
      //   state.COLLECT_LEAD = false;
      // }
      else if (!forwards && state.SHOW_RESULTS) {
        state.SHOW_RESULTS = false;
      }
      else if (!forwards && state.step > 1) {
        state.step = state.step-1;
        state.SHOW_RESULTS = false; // YES, this is a side effect. but it's the easiest way to ensure hitting the back button stops showing results page
      } else return;
    },

    SET_RESULTS(state, results) {
      const result_images = {
        'foot_ankle': './result_images/foot_ankle.png',
        'hand_elbow': './result_images/hand_elbow.png',
        'hip': './result_images/hip.png',
        'knee': './result_images/knee.png',
        'shoulder': './result_images/shoulder.png',
        'spine': './result_images/spine.png'
      }
      state.results_pic = result_images[state.exam_type];
      state.exam_results = results;
    },
    SHOW_RESULTS(state, value) {
      state.SHOW_RESULTS = value;
    },

    RESET(state) {
      Object.keys(defaultState).forEach(key => {
        state[key] = defaultState[key];
      });
    },


    SET_EXAM(state, exam_type) {
      state.exam = all_prompts[exam_type];
      // Set the exam_responses object to hold each prompt, and an empty value to later be filled by the user as they answer that prompt
      state.exam.prompts.forEach(step => {
        // Checkboxes need to be arrays to contain multiple values, otherwise we can directly set new values from null
        let empty_response = null;
        if (step.input === 'checkbox') empty_response = [];
        Vue.set(state.exam_responses, step.question.prompt, empty_response);
      })
    },
    SET_PROMPT_AND_QUESTION(state, { prompt, response }) {
      // console.log(prompt, response);
      Vue.set(state.exam_responses, prompt, response);
    }

  },
  actions: {
    reset_exam: ({ commit, dispatch }) => {
      commit('SET_LOADING', true);
      commit('RESET');
      dispatch('setup_exam');
      // TODO: ask for confirmation before resetting
      commit('SET_LOADING', false);
    },
    // Initial setup before anything happens. Called in main.js mounted()
    setup_exam: ({ commit }, manually_selected_type) => {
      commit('SET_LOADING', true);
      const exam_type = manually_selected_type || get_exam_type();
      if (exam_type) {
        // Legacy, didn't want to re write this yet
        commit('SET_VALUE', { prop: 'exam_type', val: exam_type });
        commit('SET_VALUE', { prop: 'step', val: 1 });
        // New
        commit('SET_EXAM', exam_type);
      }
      commit('SET_LOADING', false);
    },
    // Back and forth navigation between exam steps
    navigate({ state, commit, dispatch }, forwards) {
      if (forwards && state.step === state.exam?.prompts.length) { // only call results if we hit the next button AND at the final step
        commit('SHOW_RESULTS', true);
        // console.log(state.results);
        dispatch('fetch_results')
        return
      } else {
        commit('NAVIGATE_STEP', forwards);
      }
    },
    // Fetch results
    fetch_results: async({ commit, state }) => {
      try {
        commit('SET_LOADING', true);
        // const response = await axios.post('http://localhost:5001/mop-forms/us-central1/fireExpress/get_results', {
        const response = await axios.post('https://us-central1-mop-forms.cloudfunctions.net/fireExpress/get_results', {
          exam_type: state.exam_type,
          responses: state.exam_responses
        });
        const results = response.data;
        // console.log(results);
        const session = await db.collection('MOP_show_results').add({ results, fetched_on: Date.now() });
        commit('SET_SESSION_ID', session.id);
        commit('SET_RESULTS', results); // sets exam_results
      } catch(err) {
        console.log(err);
      } finally {
        commit('SET_LOADING', false);
      }
    },

  },
  modules: {
  }
})
